module.exports = __webpack_public_path__ + "static/salary_card_passport-8d375f0d4ea00bd649e54b8aa7ae1149.pdf";